import { judgeObj, logColor } from '@/shared/functions';
import { CONST_URL } from '@/shared/config';
import { dispatch } from '@@/store';
const defaultSignalRData = {
    webUrl: CONST_URL.webUrl || 'http://pusha.test.cheyipai.com',
    qs: { groupName: '01151815' },
};
let _count;
let _userStop;
const longLink = {
    _beforeConnect: (payload) => {
        _userStop = true;
        logColor('准备建立连接', 'color: green');
        const _p = judgeObj(payload) ? payload : {};
        const _d = Object.assign(defaultSignalRData, _p);
        // @ts-ignore
        $.connection.hub.url = `${_d.webUrl}/signalr`;
        // @ts-ignore
        $.connection.hub.qs = _d.qs;
        // @ts-ignore
        $.connection.hub.logging = true;
        // @ts-ignore
        const pushAuction = $.connection.pushAuction;
        // debugger;
        longLink._lifeAndError();
        return pushAuction;
    },
    _connect: () => {
        logColor('正在建立连接...', 'color: green');
        // @ts-ignore
        $.connection.hub.start().done(() => {
            // @ts-ignore
            logColor('连接成功', 'color: green');
            // @ts-ignore
            logColor('连接id为', $.connection.hub.id, 'color: green');
            clearTimeout(_count);
            // 清除轮询大屏是否真正结束接口的计时器
            logColor('退出轮询机制', 'color: green');
            dispatch.screenLoop.stopLoop({});
        }).fail((msg) => {
            logColor('连接失败', msg, 'color: red');
            // 增加轮询机制
            logColor('进入轮询机制', 'color: green');
            dispatch.screenLoop.loop({});
            clearTimeout(_count);
            _count = setTimeout(() => {
                longLink._connect();
            }, 3000);
        });
    },
    _reConnect: () => {
        // @ts-ignore
        if ($.connection.hub.disconnected) {
            // @ts-ignore
            $.connection.hub.disconnected((error) => {
                logColor('连接已断开', 'color: red');
                // @ts-ignore
                logColor('断开的连接id为', $.connection.hub.id, 'color: red');
                if (error) {
                    logColor('其他原因造成连接断开：', error, 'color: red');
                }
                // @ts-ignore
                if ($.connection.hub.lastError) {
                    // @ts-ignore
                    logColor('服务器原因造成连接断开：', $.connection.hub.lastError.message, 'color: red');
                }
                if (!_count && _userStop) {
                    logColor('即将建立长连接', 'color: red');
                    longLink._connect();
                    // 增加轮询机制
                    logColor('进入轮询机制', 'color: green');
                    dispatch.screenLoop.loop({});
                }
            });
        }
    },
    _stateChange: () => {
        // @ts-ignore
        if ($.connection.hub.stateChanged) {
            // @ts-ignore
            $.connection.hub.stateChanged((state, n) => {
                logColor('长连接旧的state', state.oldState, '长连接新的state', state.newState, ',', n, 'color: green');
            });
        }
    },
    _stop: (reLong) => {
        // @ts-ignore
        if ($.connection.hub.stop) {
            _userStop = reLong;
            logColor('关闭连接...', 'color: red');
            clearTimeout(_count);
            // @ts-ignore
            $.connection.hub.stop();
        }
    },
    _lifeAndError: () => {
        // @ts-ignore
        if ($.connection.hub.error) {
            // @ts-ignore
            $.connection.hub.error((error) => {
                logColor('长连接错误 :', error, 'color: red');
            });
        }
        // @ts-ignore
        if ($.connection.hub.connectionSlow) {
            // @ts-ignore
            $.connection.hub.connectionSlow(() => {
                logColor('长连接不稳定...', 'color: red');
                // 增加轮询机制
                logColor('进入轮询机制', 'color: green');
                dispatch.screenLoop.loop({});
            });
        }
        // @ts-ignore
        if ($.connection.hub.reconnecting) {
            // @ts-ignore
            $.connection.hub.reconnecting(() => {
                logColor('长连接即将重连', 'color: green');
            });
        }
        // @ts-ignore
        if ($.connection.hub.reconnected) {
            // @ts-ignore
            $.connection.hub.reconnected(() => {
                logColor('长连接重连成功', 'color: green');
                // 清除轮询大屏是否真正结束接口的计时器
                logColor('退出轮询机制', 'color: green');
                dispatch.screenLoop.stopLoop({});
            });
        }
    },
};
longLink._reConnect();
longLink._stateChange();
/**
 * @desc 建立长连接，如果在原页面连接断开，再重连
 * @property payload? {object}
 *           @augments payload @property webUrl?:  {string}, 请求地址
 *                                              默认值 相应环境下的地址 若无则'http://pusha.test.cheyipai.com'
 *           @augments payload @property qs?:      {string}, 传给服务器的信息：如租户信息 groupName
 *                                              默认值 登陆后获取的租户信息 默认值{groupName: '01151815'}
 *           @augments payload @property HubName?: {string}, 代理对象
 *                                              默认值 'pushAuction'
 * @argument 默认是系统内部给值，支持自定义值
 */
export function beforeLong(payload) {
    const pushHubMethod = longLink._beforeConnect(payload);
    return pushHubMethod;
}
export function connectLong() {
    longLink._connect();
}
/**
 * @desc 断开连接 离开页面的时候可以调用，如componentWillUnmount时期；
 */
export function stopLong(reLong = false) {
    longLink._stop(reLong);
}
/**
 * @desc 手动重连
 */
export function reLong() {
    stopLong(true);
}
